import * as mediasoup from "mediasoup-client";
export class SignaledDevice {
    signaling;
    device;
    constructor(signaling) {
        this.signaling = signaling;
        this.device = new mediasoup.Device();
    }
    destroy() { }
    createSendTransport(options) {
        return this.device.createSendTransport(options);
    }
    createRecvTransport(options) {
        return this.device.createRecvTransport(options);
    }
    async connect() {
        const device = new mediasoup.Device();
        this.device = device;
        if (this.signaling === undefined)
            throw new Error("signaling undefined");
        const { routerRtpCapabilities } = await this.signaling.sendWithResponse("get-rtp-capabilities");
        return device.load({ routerRtpCapabilities });
    }
}
//# sourceMappingURL=SignaledDevice.js.map